<template>
  <div class="sso-layout-container">
    <!-- header -->
    <sso-header />
    <!-- body -->
    <router-view></router-view>
    <!-- footer -->
    <sso-footer />
  </div>
</template>

<script>
import '@/views/sso/scss/sso.scss'
import ssoHeader from './sso-header.vue';
import ssoFooter from './sso-footer.vue';
export default {
  name: 'ssoLayout',
  components: {ssoHeader,ssoFooter},
  data() {
    return {
    };
  },
  methods: {
    
  }
};
</script>

<style lang="scss" scoped>
</style>